import React, { useEffect, useRef, useState } from "react";

const searchIcon = `${EASYCOMMERCE.assets}admin/img/icons/product-search-icon.png`;

const SearchForm = ({
    products,
    searchTerm,
    productSearched,
    handleProductSelect,
    searchProducts,
}) => {
    const inputRef = useRef();
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        inputRef.current.focus();
    }, []);

    return (
        <div
            className="absolute left-0 top-14 bg-white w-[200px] border border-ec-border p-[6px] rounded-lg z-50"
            style={{ boxShadow: "0px 30px 34px -2px #0000001F" }}
        >
            <div
                className={`flex justify-start items-center gap-[6px] p-2 bg-[#F8F8F8] h-[40px] rounded-lg border ${
                    isFocused ? "border-ec-secondary" : "border-ec-border"
                }`}
            >
                <img src={searchIcon} className="w-4 h-4 pointer-events-none" />

                <input
                    ref={inputRef}
                    type="text"
                    placeholder="Search"
                    className="easycommerce-report-product-search w-full"
                    value={searchTerm}
                    onChange={searchProducts}
                    onFocus={() => setIsFocused(true)}
                />
            </div>

            {searchTerm && searchTerm.length >= 3 && productSearched && (
                <>
                    {products.length > 0 ? (
                        <ul className="flex flex-col gap-2 mt-2">
                            {products.map((product) => (
                                <li
                                    key={product.id}
                                    className="p-3 m-0 font-inter text-base leading-[26px] text-ec-body 
                                    hover:bg-[#F8F8F8] rounded-lg cursor-pointer"
                                    onClick={() => {
                                        handleProductSelect(
                                            product.title,
                                            product.id
                                        );
                                    }}
                                >
                                    {product.title}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p className="py-6 text-center font-inter text-base leading-[26px] text-ec-secondary">
                            No products found
                        </p>
                    )}
                </>
            )}
        </div>
    );
};

export default SearchForm;
